/*********************** Custom JS for Boost AI Search & Discovery ************************/

(function () {
  'use strict';

  /* Prevent duplicate listeners if Shopify or a theme section evaluates this file twice. */
  if (window.__mrkBoostCustomJsLoaded) {
    if (typeof window.mrkBoostRefresh === 'function') window.mrkBoostRefresh();
    return;
  }
  window.__mrkBoostCustomJsLoaded = true;

  var MOBILE_BREAKPOINT = 769;
  var FILTER_SYNC_DELAY = 200;
  var FRAME_RATIO_TOLERANCE = 0.01;

  var frameState = {
    frames: null,
    source: null,
    sourceObserver: null
  };

  var renderState = {
    scheduled: false,
    observer: null,
    filterTimer: 0,
    initializedFrameInputs: typeof WeakSet === 'function' ? new WeakSet() : null
  };

  var stickyState = {
    bound: false,
    ticking: false,
    measuring: false,
    metrics: null,
    activeElement: null,
    resizeObserver: null,
    observedList: null,
    observedHeader: null
  };

  /* ------------------------------------------------------------------
   * Ctrl/Command + click: open product links in a new tab.
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    if (!event.ctrlKey && !event.metaKey) return;

    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var product = target.closest(
      '.boost-sd__product-item, .boost-sd__product-item-list-view-layout'
    );

    if (!product ||
        target.closest('.boost-sd__popup-select-option') ||
        target.closest('.boost-sd__bulk-quantity') ||
        (target.closest('.boost-sd__product-swatch') &&
         !target.closest('.boost-sd__product-swatch-more'))) {
      return;
    }

    var link = target.closest('.boost-sd__product-link') ||
      product.querySelector('.boost-sd__product-link');
    if (!link || !link.href) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    window.open(link.href, '_blank', 'noopener');
  }, true);


  /* ------------------------------------------------------------------
   * Frame data and rendering.
   * Keeps the working single-frame .wd-frame-* output.
   * ------------------------------------------------------------------ */
  function mrkNormalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function mrkInvalidateFrameIndex() {
    frameState.frames = null;
  }

  function mrkObserveFrameSource(source) {
    if (frameState.sourceObserver) frameState.sourceObserver.disconnect();
    frameState.sourceObserver = null;

    if (!source || typeof MutationObserver !== 'function') return;

    frameState.sourceObserver = new MutationObserver(function () {
      mrkInvalidateFrameIndex();
      mrkScheduleRender();
    });

    frameState.sourceObserver.observe(source, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function mrkFrameIndex() {
    var source = document.getElementById('mrk-frames-data');
    if (!source) return [];

    if (frameState.source !== source) {
      frameState.source = source;
      frameState.frames = null;
      mrkObserveFrameSource(source);
    }

    if (frameState.frames) return frameState.frames;

    var parser = document.createElement('div');
    parser.innerHTML = source.innerHTML;

    var frames = [];
    var images = parser.querySelectorAll('.mrk-frame-image-item');

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      var ratio = parseFloat(image.getAttribute('ratio'));
      if (!isFinite(ratio)) continue;

      var frame = {
        id: image.getAttribute('frame-id') || '',
        ratio: ratio,
        type: image.getAttribute('type') || '',
        typeKey: mrkNormalize(image.getAttribute('type')),
        color: mrkNormalize(image.getAttribute('color')),
        altName: mrkNormalize(image.getAttribute('alt-name')),
        src: image.getAttribute('src') || '',
        avif: image.getAttribute('avif-src') || '',
        lr: parseFloat(image.getAttribute('left_right')) || 0,
        tb: parseFloat(image.getAttribute('top_bottom')) || 0,
        html: image.outerHTML
      };

      /* frame-id is preferred, but the fallback prevents empty IDs from making
         different colours look identical to the update routine. */
      frame.key = frame.id || [
        frame.typeKey,
        frame.ratio,
        frame.color,
        frame.altName,
        frame.src,
        frame.avif
      ].join('|');

      frames.push(frame);
    }

    frameState.frames = frames;
    return frames;
  }

  function mrkSelectedFrameColor() {
    var checked = document.querySelector('[name="mrk-collection-frame"]:checked');
    return checked ? mrkNormalize(checked.value) : 'black';
  }

  function mrkFindFrame(ratio, type, color) {
    var frames = mrkFrameIndex();
    var typeKey = mrkNormalize(type);
    var colorKey = mrkNormalize(color);
    var fallback = null;

    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i];
      if (frame.typeKey !== typeKey) continue;
      if (Math.abs(frame.ratio - ratio) >= FRAME_RATIO_TOLERANCE) continue;

      if (!fallback) fallback = frame;
      if (colorKey && (frame.color === colorKey || frame.altName === colorKey)) {
        return frame;
      }
    }

    return fallback;
  }

  function mrkEnsureFrameNode(holder) {
    var picture = holder.querySelector('.wd-frame-pic');
    if (picture) return picture;

    picture = document.createElement('picture');
    picture.className = 'wd-frame-pic';
    picture.setAttribute('aria-hidden', 'true');

    var avif = document.createElement('source');
    avif.className = 'wd-frame-avif';
    avif.type = 'image/avif';

    var webp = document.createElement('source');
    webp.className = 'wd-frame-webp';
    webp.type = 'image/webp';

    var image = document.createElement('img');
    image.className = 'wd-frame-img';
    image.alt = '';
    image.decoding = 'async';

    picture.appendChild(avif);
    picture.appendChild(webp);
    picture.appendChild(image);
    holder.appendChild(picture);

    return picture;
  }

  function mrkRemoveGeneratedFrame(box, holder) {
    var picture = holder.querySelector('.wd-frame-pic');
    if (picture) picture.remove();
    box.style.removeProperty('--tb');
    box.style.removeProperty('--lr');
  }

  function mrkApplyFrames() {
    var boxes = document.querySelectorAll('.mrk-collection-item-frames-wrapper');
    if (!boxes.length) return;

    var color = mrkSelectedFrameColor();
    var type = window.FrameType || 'Print';
    var noFrame = color === 'none';

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var holder = box.querySelector('.mrk-frames-wrapper');
      if (!holder) continue;

      if (box.getAttribute('hasframe') !== 'true' || noFrame) {
        mrkRemoveGeneratedFrame(box, holder);
        continue;
      }

      var ratio = parseFloat(box.getAttribute('ratio'));
      if (!isFinite(ratio) || ratio <= 0) continue;

      var frame = mrkFindFrame(ratio, type, color);
      if (!frame || !frame.src) continue;

      var picture = mrkEnsureFrameNode(holder);
      var image = picture.querySelector('.wd-frame-img');

      if (image.getAttribute('data-frame-key') !== frame.key) {
        var avif = picture.querySelector('.wd-frame-avif');
        var webp = picture.querySelector('.wd-frame-webp');

        if (frame.avif) avif.setAttribute('srcset', frame.avif);
        else avif.removeAttribute('srcset');

        webp.setAttribute('srcset', frame.src);
        image.src = frame.src;
        image.setAttribute('data-frame-key', frame.key);
        image.setAttribute('data-frame-id', frame.id);
        image.setAttribute('color', frame.color);
      }

      var topBottom = 'calc(' + (frame.tb / 2) + '% - 2px)';
      var leftRight = 'calc(' + (frame.lr / 2) + '% - 2px)';

      if (box.style.getPropertyValue('--tb') !== topBottom) {
        box.style.setProperty('--tb', topBottom);
      }
      if (box.style.getPropertyValue('--lr') !== leftRight) {
        box.style.setProperty('--lr', leftRight);
      }
    }
  }

  /* Compatibility helper retained from the original version. */
  function getFrames(aspectRatio, hasFrames, type) {
    if (!hasFrames) return '';

    var ratio = parseFloat(aspectRatio);
    var typeKey = mrkNormalize(type);
    if (!isFinite(ratio)) return '';

    var frames = mrkFrameIndex();
    var html = [];

    for (var i = 0; i < frames.length; i++) {
      if (frames[i].typeKey === typeKey &&
          Math.abs(frames[i].ratio - ratio) < FRAME_RATIO_TOLERANCE) {
        html.push(frames[i].html);
      }
    }

    return html.join('');
  }


  /* ------------------------------------------------------------------
   * Frame-filter UI and reliable selected-filter count.
   * ------------------------------------------------------------------ */
  function mrkFrameFilterTarget() {
    return window.innerWidth > MOBILE_BREAKPOINT
      ? document.querySelector('.boost-sd__filter-tree-horizontal-option-list')
      : document.querySelector('.mrk-count-frames-wrapper');
  }

  function mrkInjectedFrameFilter() {
    return document.querySelector(
      '.boost-sd__filter-tree-horizontal-option-list ' +
      '.mrk-collection-filter-frame-wrapper, ' +
      '.mrk-count-frames-wrapper .mrk-collection-filter-frame-wrapper'
    );
  }

  function addFrameFilters() {
    var source = document.getElementById('filter-frames-items');
    var target = mrkFrameFilterTarget();
    if (!source || !target) return null;

    var filter = mrkInjectedFrameFilter();

    if (!filter) {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        target.insertAdjacentHTML('beforeend', source.innerHTML);
      } else {
        target.insertAdjacentHTML('afterbegin', source.innerHTML);
      }
      filter = mrkInjectedFrameFilter();
    } else if (filter.parentNode !== target) {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        target.appendChild(filter);
      } else {
        target.insertBefore(filter, target.firstChild);
      }
    }

    return filter;
  }

  function mrkUpdateFilterCount() {
    var toggle = document.getElementById('boost-sd__filter-tree-toggle-button');
    if (!toggle) return;

    var count = document.querySelectorAll(
      '.boost-sd__filter-option-item-button--selected'
    ).length;

    if (count > 0) toggle.setAttribute('data-count', String(count));
    else toggle.removeAttribute('data-count');
  }

  function mrkInputWasInitialized(input) {
    if (!input) return true;

    if (renderState.initializedFrameInputs) {
      if (renderState.initializedFrameInputs.has(input)) return true;
      renderState.initializedFrameInputs.add(input);
      return false;
    }

    if (input.getAttribute('data-mrk-initialized') === 'true') return true;
    input.setAttribute('data-mrk-initialized', 'true');
    return false;
  }

  function mrkDispatchInitialFrameChange() {
    var checked = document.querySelector('[name="mrk-collection-frame"]:checked');
    if (!checked || mrkInputWasInitialized(checked)) return;

    var changeEvent;
    if (typeof Event === 'function') {
      changeEvent = new Event('change', { bubbles: true });
    } else {
      changeEvent = document.createEvent('Event');
      changeEvent.initEvent('change', true, false);
    }
    checked.dispatchEvent(changeEvent);
  }

  function mrkScheduleFilterSync() {
    window.clearTimeout(renderState.filterTimer);
    renderState.filterTimer = window.setTimeout(function () {
      renderState.filterTimer = 0;
      mrkDispatchInitialFrameChange();
      mrkApplyFrames();
      mrkUpdateFilterCount();
      mrkScheduleStickyMeasure();
    }, FILTER_SYNC_DELAY);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;

    if (target.name === 'mrk-collection-frame') {
      mrkInputWasInitialized(target);
      mrkApplyFrames();
      mrkUpdateFilterCount();
      mrkScheduleFilterSync();
      return;
    }

    if (typeof target.closest === 'function' &&
        target.closest('#boost-sd__filter-tree-wrapper')) {
      mrkScheduleFilterSync();
    }
  });

  /* Boost applies its selected class after click handling, so count afterwards. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    if (target.closest(
      '.boost-sd__filter-option-item-button, ' +
      '#boost-sd__filter-tree-toggle-button, ' +
      '.mrk-collection-filter-frame-wrapper'
    )) {
      mrkScheduleFilterSync();
    }
  });


  /* ------------------------------------------------------------------
   * Sticky filter bar: one passive handler, rAF batching and live sizing.
   * ------------------------------------------------------------------ */
  function mrkStickyElement() {
    return window.innerWidth < MOBILE_BREAKPOINT
      ? document.querySelector('.boost-sd__toolbar.boost-sd__toolbar--2_1')
      : document.getElementById('boost-sd__filter-tree-wrapper');
  }

  function mrkClearStickyElement(element) {
    if (!element) return;
    element.classList.remove('mrk-fixed-collection-filters');
    element.style.minHeight = '';
  }

  function mrkObserveStickyLayout(list, header) {
    if (typeof ResizeObserver !== 'function') return;

    if (!stickyState.resizeObserver) {
      stickyState.resizeObserver = new ResizeObserver(function () {
        mrkScheduleStickyMeasure();
      });
    }

    if (stickyState.observedList === list && stickyState.observedHeader === header) {
      return;
    }

    stickyState.resizeObserver.disconnect();
    stickyState.observedList = list || null;
    stickyState.observedHeader = header || null;

    if (list) stickyState.resizeObserver.observe(list);
    if (header) stickyState.resizeObserver.observe(header);
  }

  function mrkMeasureSticky() {
    stickyState.measuring = false;

    var element = mrkStickyElement();
    var collection = document.querySelector('.boost-sd__filter-product-list');
    var list = document.querySelector('.boost-sd__product-list') || collection;
    var header = document.querySelector('#header-component .header__row');

    if (stickyState.activeElement && stickyState.activeElement !== element) {
      mrkClearStickyElement(stickyState.activeElement);
    }
    stickyState.activeElement = element || null;

    if (!element || !collection || !list) {
      mrkClearStickyElement(element);
      stickyState.metrics = null;
      mrkObserveStickyLayout(null, null);
      return;
    }

    var wasFixed = element.classList.contains('mrk-fixed-collection-filters');
    if (wasFixed) element.classList.remove('mrk-fixed-collection-filters');

    var elementRect = element.getBoundingClientRect();
    var listRect = list.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var headerHeight = header ? header.getBoundingClientRect().height : 0;

    stickyState.metrics = {
      element: element,
      top: elementRect.top + scrollTop,
      height: elementRect.height,
      listBottom: listRect.bottom + scrollTop,
      headerHeight: headerHeight
    };

    element.style.setProperty('--height', elementRect.height + 'px');
    element.style.setProperty('--header', headerHeight + 'px');

    if (wasFixed) element.classList.add('mrk-fixed-collection-filters');
    mrkObserveStickyLayout(list, header);
    mrkOnScroll();
  }

  function mrkScheduleStickyMeasure() {
    if (stickyState.measuring) return;
    stickyState.measuring = true;
    window.requestAnimationFrame(mrkMeasureSticky);
  }

  function mrkOnScroll() {
    if (stickyState.ticking) return;
    stickyState.ticking = true;

    window.requestAnimationFrame(function () {
      stickyState.ticking = false;

      var metrics = stickyState.metrics;
      if (!metrics || !metrics.element.isConnected) return;

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var shouldFix = scrollTop > metrics.top &&
        (scrollTop + 120) <= metrics.listBottom;

      if (shouldFix) {
        metrics.element.classList.add('mrk-fixed-collection-filters');
        metrics.element.style.minHeight = metrics.height + 'px';
      } else {
        mrkClearStickyElement(metrics.element);
      }
    });
  }

  function initStickyBar() {
    mrkScheduleStickyMeasure();
    if (stickyState.bound) return;

    stickyState.bound = true;
    window.addEventListener('scroll', mrkOnScroll, { passive: true });
    window.addEventListener('resize', function () {
      mrkScheduleRender();
      mrkScheduleStickyMeasure();
    }, { passive: true });
    window.addEventListener('load', mrkScheduleStickyMeasure, { once: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(mrkScheduleStickyMeasure);
    }
  }


  /* ------------------------------------------------------------------
   * Horizontal filter dropdowns: keep every panel inside the viewport.
   *
   * Boost positions each dropdown absolutely at its filter's left edge and the
   * theme gives it a fixed 295px width (drool.css --style1). The rightmost
   * filters therefore open off-screen — worse the more filters merchandising
   * adds, since the row is centred and grows outward. Generic on purpose: a
   * "last two children" CSS rule silently stops covering the right filters as
   * soon as the filter count changes.
   *
   * translateX rather than left/right: Boost owns this element's positioning
   * and rewrites its inline styles on re-render, so a transform layers on top
   * instead of fighting it, and works whichever side it anchors from.
   * ------------------------------------------------------------------ */
  var PANEL_SELECTOR =
    '.boost-sd__filter-option--horizontal .boost-sd__filter-option-itemwrapper--horizontal';
  var PANEL_EDGE_GAP = 12;

  var panelState = {
    scheduled: false,
    timer: 0
  };

  function mrkClampPanel(panel) {
    /* Always measure from the natural position — without this reset each pass
       would compound the previous shift and walk the panel off the other side. */
    panel.style.transform = '';

    var rect = panel.getBoundingClientRect();
    /* Closed panels measure 0 and are left alone (the reset above already
       cleared any transform from when they were open). */
    if (!rect.width) return;

    var viewport = document.documentElement.clientWidth;
    var shift = 0;

    if (rect.right > viewport - PANEL_EDGE_GAP) {
      shift = (viewport - PANEL_EDGE_GAP) - rect.right;
    }
    /* A panel wider than the viewport can't fit either way; pin its left edge
       so the options stay reachable rather than pushing the start off-screen. */
    if (rect.left + shift < PANEL_EDGE_GAP) {
      shift = PANEL_EDGE_GAP - rect.left;
    }

    if (!shift) return;

    /* Boost's own stylesheet may already transform this panel (open animation,
       or positioning we can't see from here). Clearing the INLINE property
       above doesn't remove a stylesheet one, so compose rather than replace:
       our translate goes first, which shifts the already-transformed box by
       exactly the measured overflow. Dropping `base` here would silently undo
       whatever Boost was doing. */
    var base = window.getComputedStyle(panel).transform;
    var move = 'translateX(' + Math.round(shift) + 'px)';
    panel.style.transform = (!base || base === 'none') ? move : move + ' ' + base;
  }

  function mrkClampFilterPanels() {
    var panels = document.querySelectorAll(PANEL_SELECTOR);
    for (var i = 0; i < panels.length; i++) mrkClampPanel(panels[i]);
  }

  function mrkScheduleClamp() {
    if (panelState.scheduled) return;
    panelState.scheduled = true;

    window.requestAnimationFrame(function () {
      panelState.scheduled = false;
      mrkClampFilterPanels();
    });
  }

  /* The page observer only watches childList, so a dropdown Boost opens by
     toggling a class alone would never reach mrkAfterRender. One click hook
     covers that: rAF for the synchronous case, plus a single short follow-up
     for builds that render the panel a tick later. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('.boost-sd__filter-option--horizontal')) return;

    mrkScheduleClamp();
    window.clearTimeout(panelState.timer);
    panelState.timer = window.setTimeout(mrkClampFilterPanels, 60);
  });


  /* ------------------------------------------------------------------
   * Render driver and Boost integration.
   * ------------------------------------------------------------------ */
  function mrkAfterRender() {
    addFrameFilters();
    mrkApplyFrames();
    initStickyBar();
    /* Re-clamp after every Boost render. The resize listener in initStickyBar
       routes through here too, so viewport changes are covered by this call. */
    mrkClampFilterPanels();

    /* Immediate update handles settled DOM; delayed update handles Boost's
       asynchronous selected-class update. */
    mrkUpdateFilterCount();
    mrkScheduleFilterSync();
  }

  function mrkScheduleRender() {
    if (renderState.scheduled) return;
    renderState.scheduled = true;

    window.requestAnimationFrame(function () {
      renderState.scheduled = false;
      mrkAfterRender();
    });
  }

  function mrkWatchPage() {
    if (renderState.observer || typeof MutationObserver !== 'function') return;

    renderState.observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        var target = mutation.target;

        /* Ignore the frame nodes created/removed by this script. */
        if (target && typeof target.closest === 'function' &&
            target.closest('.mrk-frames-wrapper')) {
          continue;
        }

        if ((mutation.addedNodes && mutation.addedNodes.length) ||
            (mutation.removedNodes && mutation.removedNodes.length)) {
          mrkScheduleRender();
          return;
        }
      }
    });

    renderState.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function mrkStart() {
    mrkWatchPage();
    mrkScheduleRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mrkStart, { once: true });
  } else {
    mrkStart();
  }

  try {
    if (typeof boostWidgetIntegration !== 'undefined' &&
        typeof boostWidgetIntegration.regisCustomization === 'function') {
      boostWidgetIntegration.regisCustomization(mrkAfterRender, 'filter');

      /* Retains compatibility with Boost builds that invoke the unscoped hook. */
      try {
        boostWidgetIntegration.regisCustomization(mrkAfterRender);
      } catch (unscopedError) {
        /* The observer and scoped hook cover builds without this registration. */
      }
    }
  } catch (registrationError) {
    /* Direct observation still initializes and refreshes the integration. */
  }

  /* Small compatibility surface for existing theme code and manual refreshes. */
  window.getFrames = getFrames;
  window.mrkApplyFrames = mrkApplyFrames;
  window.mrkUpdateFilterCount = mrkUpdateFilterCount;
  window.mrkBoostRefresh = mrkScheduleRender;
})();
